import React, { useEffect } from 'react'

import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { alertsSection, isMinMaxPriceTabLoading } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import MinMaxPriceTable from "Pages/ReportsAlerts/Alerts/Conditions/MinMax/Table"
import MinMaxPriceDrawer from "Pages/ReportsAlerts/Alerts/Conditions/MinMax/Drawer"
import { BACKEND_APIS } from "@constants"
import { isTourDemoActive } from "@signals/app"


export default function MinMaxPriceBlock() {

	const {
		isAlertSubmitting,
		onEditAlert,
		onSubmitAlert,
		tableData,
		getTableData,
		isTableLoading,
		onDeleteAlert,
		filterConditions
	} = useAlertsTableData(`${BACKEND_APIS.CONDITIONS}/min-max`)

	useEffect(() => {
		isMinMaxPriceTabLoading.value = true
		getTableData()
			.then(() => isMinMaxPriceTabLoading.value = false)
			.catch(() => isMinMaxPriceTabLoading.value = false)
	}, [])

	if (alertsSection.value !== ALERTS.MIN_MAX_PRICE) return <></>

	return <>
		{!(isTourDemoActive.value && !tableData?.length) && <MinMaxPriceTable
			data={tableData}
			onDeleteAlert={onDeleteAlert}
			isLoading={isTableLoading}
			onEditAlert={onEditAlert}
			filterConditions={filterConditions}
		/>}
		<MinMaxPriceDrawer
			isLoading={isAlertSubmitting}
			onSubmitAlert={onSubmitAlert}
		/>
	</>

}